import {Moment} from "moment/moment"

export type OptionType = {
    value: number | string
    label: string
}

export type AttributeRuleType = {
    name: string
    type: string
    alias: string
    length: number
    mask: string
    is_deleted: boolean
    pos: number
    required: boolean
    created_at: string | Moment
    updated_at: string | Moment
    options: Array<OptionType>
    showInTable: boolean
}

export type AttributeType = {
    alias: string
    value: string | Array<string>
    created_at: string
    updated_at: string
}


export enum UserTypeEnum {
    ADMIN_SYSTEM = 1,
    OPERATOR_SYSTEM = 2,
    BUH_SYSTEM = 3,
    ADMIN_COMPANY = 4,
    OPERATOR_COMPANY = 5,
    BUH_COMPANY = 6,
}

export enum PSLeakLocalLogTypeEnum {
    NoDataHVS = 1,
    NoDataGVS = 2,
    NoDataLeak = 3,
    NoDataVKT = 4,
    LeakHVS = 21,
    LeakGVS = 22,
    Leak = 23,
    LeakVKT = 24,
}